<!--阳西荔枝-->
<template>
 <div class='container' :style='style'>
   <div class='top'>
        <!-- <div class='weather-section'>
          <chart-box>
             <Wheather :countyId="countyId"/>
          </chart-box>
         </div>
        <div class='title-img'>
          <img src='//img.yimutian.com/crm/5fc5b9402d211f71024e42a602e00045.png'/>
        </div>
        <div class='logo-section'>
          <img class="logo-ymt" @click="goHome" src="//img.yimutian.com/crm/5d916475b827736e3b0385c31babb7cc.png">
        </div> -->
   </div>
   <div class='bottom'>
      <div class='left-section'>
            <div class='left-top'>
              <div class='rank-provider'>
                  <!-- <div class='block-title title-back-one'>
                     <span class='block-big-title'>最受欢迎的供应商</span>
                  </div>
                  <div class='block-sub-title'>
                     最受采购商欢迎的{{currentAddr}}{{currentPropductName}}供应商TOP30
                  </div> -->
                  <div class="hz-title">
                    <img src="https://img.yimutian.com/crm/5ff7ff082d211f71026e26b202a40043.png">
                    <p class="title-text">最受欢迎供应商</p>
                  </div>
                  <div class='rank-provider-container'>
                        <!-- <chart-box>
                           <PopularProvider :productId="productId" :countyId="329"/>
                       </chart-box> -->
                    <PopularProvider :productId="productId" :countyId="329"/>
                  </div>
              </div>

               <div class='capture-rate hz-bg'>
                  <!-- <div  class='block-title title-back-one'>
                     <span class='block-big-title'>采购渗透率</span>
                  </div>
                  <div class='block-sub-title'>
                     全国{{currentPropductName}}地级行政区渗透率+全国{{currentPropductName}}采购商渗透率
                  </div> -->
                  <div class="hz-title">
                    <img src="https://img.yimutian.com/crm/5ff7ff00b827730a886df51c02560043.png" class="title_bottom">
                    <p class="title-text">采购渗透率</p>
                  </div>
                  <div class='rate-container'>
                       <!--采购渗透率-->
                        <!-- <chart-box> -->
                          <div class='top-ration'>
                            <div class='ration-city'>
                                <BuyerRationCity textSize="20" :productId="productId" :countyId="countyId"/>
                            </div>
                            <div class='ration-person'>
                              <BuyerRationPerson
                                :productId="productId"
                                :countyId="countyId"
                                textSize="20"/>
                                <!-- <buyerRationPerson></buyerRationPerson> -->
                            </div>
                           </div>
                           <div class='bottom-ration'>
                              <div class='ration-words'>
                                地级行政区渗透率：{{currentAddr}}{{currentPropductName}}在全国地级行政区的渗透率<br/>
                                采购商渗透率：{{currentAddr}}{{currentPropductName}}在全国{{currentPropductName}}采购商中的渗透率
                              </div>
                           </div>
                       <!-- </chart-box> -->
                  </div>
              </div>
            </div>

            <div class='left-middle hz-bg'>
                  <!-- <div class='block-title single-line-title title-back-two'>
                     <span class='block-big-title'>供应热度</span>
                     <span class='block-big-sub-title'>·{{currentAddr}}{{currentPropductName}}供应信息发布次数</span>
                  </div> -->
                  <div class="hz-title">
                    <img src="https://img.yimutian.com/crm/5ff7ff10b827730a886df52b055b0043.png" class="title_bottom">
                    <p class="title-text">供应热度</p>
                  </div>
                  <div class='hot-degree'>
                     <!--供应热度-->
                      <!-- <chart-box> -->
                        <ProvideHot style="height:100%;margin-top:-30px;" :productId="productId" :countyId="countyId"/>
                      <!-- </chart-box> -->
                  </div>
            </div>
            <div class='left-bottom hz-bg'>
                 <!-- <div class='block-title single-line-title title-back-three'>
                     <span class='block-big-title'>采购商指数</span>
                     <span class='block-big-sub-title'>·由{{currentAddr}}{{currentPropductName}}采购商的搜索、查看、联系下单等行为数据构成，旨在反应{{currentAddr}}{{currentPropductName}}的市场采购热度</span>
                  </div> -->
                  <div class="hz-title">
                    <img src="https://img.yimutian.com/crm/5ff7ff10b827730a886df52b055b0043.png" class="title_bottom">
                    <p class="title-text">采购商指数</p>
                  </div>
                  <div class='hot-degree'>
                      <!--采购商指数-->
                       <!-- <chart-box> -->
                          <BuyerData
                            style="height:100%;margin-top:-30px;"
                            :productId="productId"
                            :countyId="countyId"
                            :fontSize="24"
                            fontWeight="bold"
                            :legendFontSize="21"/>
                       <!-- </chart-box> -->
                  </div>
            </div>
      </div>
      <div class='middle-section hz-bg'>
            <!-- <div class='middle-title'>
                  <div class='block-title title-back-one'>
                     <span class='block-big-title'>销售流向</span>
                  </div>
                  <div class='block-sub-title'>
                     {{currentAddr}}{{currentPropductName}}的采购商来源分布
                  </div>
            </div> -->
            <div class="hz-title">
              <img src="https://img.yimutian.com/crm/5ff7ff0c2d211f71026e26b705150043.png" class="title_bottom">
              <p class="title-text">销售流向</p>
            </div>
            <div class='middle-map'>
               <!--中国地图-->
               <!-- <chart-box> -->
                   <ChinaMap
                    :productId="productId"
                    :countyId="countyId"
                    mapColor="#27B6FF"/>
               <!-- </chart-box> -->
            </div>
      </div>
      <div class='right-section'>
            <div class='right-top right-relative hz-bg'>
                  <!-- <div class='block-title  title-back-four'>
                     <span class='block-big-title'>平台综合价格</span>
                  </div> -->
                <div class="hz-title">
                  <img src="https://img.yimutian.com/crm/5ff7ff10b827730a886df52b055b0043.png" class="title_bottom">
                  <p class="title-text">平台综合价格</p>
                </div>
                  <div class='block-sub-title clearfix right-tab-pos'>
                    <!-- {{currentAddr}}{{currentPropductName}}的平台综合价格 -->
                     <TabBar defaultValue="糯米滋" :list="tagList" :limit="4" @change="tabChange" class="pull-right"/>
                  </div>
                  <div class='place-price chart-size'>
                     <!--产地价格-->
                       <!-- <chart-box> -->
                         <ProductOriginPrice
                          :productId="ymtAverageProductId"
                          :secondProductId="ymtAverageProductId"
                          :countyId="329"
                          legendPosition="7%"
                          :legendFontSize="21"
                          :fontSize="24"
                          fontWeight="bold"
                          :showCount="10"/>
                       <!-- </chart-box> -->
                  </div>
            </div>
            <div class='right-middle right-relative hz-bg'>
               <div class="hz-title">
                 <img
                    src="https://img.yimutian.com/crm/5ff7ff10b827730a886df52b055b0043.png"
                    class="title_bottom">
                  <p class="title-text">批发市场综合价格</p>
                </div>
                <div class='block-title single-line-title title-back-five right-tab-pos'>
                    <!-- <span class='block-big-title'>批发市场综合价格</span> -->
                    <!-- <span class='block-big-sub-title'>全国批发市场的{{currentAddr}}{{currentPropductName}}综合价格</span> -->
                    <TabBar :list="tagList" :limit="4" @change="tabMarkChange" defaultValue="糯米滋" class="pull-right"/>
                </div>
                  <div class='market-price chart-size'>
                     <!--市场价格+规格-->
                       <!-- <chart-box> -->
                          <MarketPrice
                            :productId="saleAverageProductId"
                            :secondProductId="saleAverageProductId"
                            legendPosition="7%"
                            :countyId="329"
                            :legendFontSize="21"
                            :fontSize="24"
                            fontWeight="bold"
                            :showCount="10"/>
                       <!-- </chart-box> -->
                  </div>
            </div>
            <div class='right-bottom hz-bg'>
                  <!-- <div class='block-title single-line-title title-back-six'>
                     <span class='block-big-title'>热门采购城市</span>
                     <span class='block-big-sub-title'>·本年度{{currentAddr}}{{currentPropductName}}采购商来源城市TOP30，以及去年同期对比</span>
                  </div> -->
                  <div class="hz-title">
                    <img src="https://img.yimutian.com/crm/5ff7ff10b827730a886df52b055b0043.png">
                    <p class="title-text">热门采购城市</p>
                  </div>
                  <div class='hot-city chart-size' style="margin-top:-30px;width:100%;">
                     <!--热门采购城市-->
                       <!-- <chart-box> -->
                           <HotCity
                            style="height:100%;width:100%;"
                            :productId="productId"
                            :countyId="countyId"
                            :legendFontSize="21"
                            :fontSize="24"
                            fontWeight="bold"
                            :showCount="10"
                            :xlableTop="4"/>
                       <!-- </chart-box> -->
                  </div>
            </div>
       </div>
   </div>
 </div>
</template>

<script>
import { mapState } from 'vuex'
import { http } from '@/http'
import Wheather from '@/components/Wheather/index.vue' // 天气组件
import PopularProvider from './components/ProductOriginPrice.vue'
import ChinaMap from '@/components/ChinaMap/index.vue'
import BuyerRationCity from '@/components/BuyerRationCity/index.vue'// 采购渗透率
import BuyerRationPerson from '@/components/BuyerRationPerson/index.vue'
import ProvideHot from '@/components/ProvideHot/index.vue'
import BuyerData from '@/components/BuyerData/index.vue'// 供应商指数
import ProductOriginPrice from '@/components/ProductOriginPrice/index.vue'// 产地价格
import MarketPrice from '@/components/MarketPrice/index.vue'
import HotCity from '@/components/HotCity/index.vue'// 市场价格
import ChartBox from '@/components/ChartBox/index.vue' // 图表外框
import TabBar from './components/TabBar.vue'

// 广东荔枝
//

export default {
  data () {
    return {
      style: {},
      // 默认阳西荔枝
      countyId: 20,
      productId: 8048, // 9008 生蚝
      currentAddr: '惠州',
      currentPropductName: '荔枝',
      tagCofnig: [],
      ymtAverageProductId: 7495,
      saleAverageProductId: 7495,
      tagList: []
    }
  },
  components: {
    ChinaMap,
    ChartBox,
    ProvideHot,
    BuyerData,
    BuyerRationCity,
    BuyerRationPerson,
    ProductOriginPrice,
    MarketPrice,
    HotCity,
    Wheather,
    PopularProvider,
    TabBar
  },
  methods: {
    // 页面适配
    setPageScale () {
      let winW = parseInt(document.body.clientWidth)
      let winH = parseInt(document.body.clientHeight)
      let ratioW = winW / 4088
      let ratioH = winH / 1730
      this.style = {
        transformOrigin: 'left top',
        transform: `scale(${ratioW},${ratioH})`
      }
    },
    tabChange (t) {
      this.ymtAverageProductId = t.id
    },
    tabMarkChange (t) {
      this.saleAverageProductId = t.id
    },
    goHome () {
      if (!this.isVIP) return
      this.$router.replace({
        name: 'home',
        query: {
          province_id: 20
        }
      })
    }
  },
  created () {
    // params.product_id
    this.$route.params.product_id = 8048
    http.get('/canmou/tianji/product/product_list?county_id=329').then(res => {
      let resData = res.data.data || []
      this.tagList = resData
      this.productId = 8048
      if (this.tagList.length) {
        this.saleAverageProductId = this.tagList[0].id
        this.ymtAverageProductId = this.tagList[0].id
      }
    })
  },
  mounted () {
    this.setPageScale()
  },
  computed: {
    ...mapState({
      isVIP: state => state.user.isVIP
    })
  }
}
</script>
<style lang="less" scoped>
.ration-words{
   text-align:left;
   color:#0efcff;
}
.top-ration{
   width:100%;
   height:344px;
}
.bottom-ration{
   width:100%;
   height:80px;
   line-height:25px;
   font-size:20px;
   color:#4c6397;
   padding-left:45px;
}
.ration-city,.ration-person{
   position:relative;
   float:left;
   width:50%;
   height:344px;
}

.title-back-one{
   background:url(http://img.yimutian.com/crm/5d9169212d211f714f03890bd0c868bb.png) left center no-repeat;
   background-size:contain;
}
.title-back-two{
    background:url(http://img.yimutian.com/crm/5d916a032d211f714f038998aad145b8.png) left center no-repeat;
    background-size:contain;
}
.title-back-three{
    background:url(http://img.yimutian.com/crm/5d916a572d211f714f0389dff30e2cf0.png) left center no-repeat;
    background-size:contain;
}
.title-back-four{
    background:url(http://img.yimutian.com/crm/5d916a702d211f714f0389fa35b388d9.png) left center no-repeat;
    background-size:contain;
}
/*市场价格规格*/
.title-back-five{
    // background:url(http://img.yimutian.com/crm/5d916a932d211f714f038a04481a6392.png) left center no-repeat;
    // background-size:contain;
}
.title-back-six{
    background:url(http://img.yimutian.com/crm/5d916ade2d211f714f038a1cd97844a7.png) left center no-repeat;
    background-size:contain;
}
.title-img{
   display:inline-block;
   margin-top:46px;
}
.title-img img {
  height:60px;
  width:auto;
}
.title-section{
   text-align:center;
   position:absolute;
   height:100%;
   left:772px;
   right:175px;
   background:url(http://img.yimutian.com/crm/5d916755b827736e3b0387c8a34a6139.png) center center no-repeat;
   background-size:auto 100%;
}
.weather-section{
   position:absolute;
   left:36px;
   top:46px;
   width:850px;
   height:60px;
}
.logo-section{
   position:absolute;
   right:26px;
   top:46px;
   img {
     width: auto;
     display: inline-block;
     vertical-align: middle;
     margin-right: 32px;
   }
   .logo-ymt {
     width: 118px;
     cursor: pointer;
   }
  .logo-gd {
    width: 76px;
  }
}
.single-line-title{
  margin-bottom:24px;
}
.right-top{
  height:33%;
  // height:539px;
  width:100%;
  margin-bottom:22px;
  position: relative;
}

.right-middle,.right-bottom{
  height:33%;
  //  height:462px;
   width:100%;
   margin-bottom:22px;
}

.middle-map{
  width:100%;
  height:90%;
  // height:1380px;
  position:relative;
}
.place-price{
   height:410px;
   margin-left:33px;
}
.hot-city{
   height:370px;
   position:relative;
}
.hot-degree{
  //  height:365px;
  height:82%;
   position:relative;
}
.market-price{
    height:370px;
}
.left-bottom{
  // height:455px;
  height: 33%;
  width:100%;
}
.left-middle{
   width:100%;
  //  height:445px;
  height: 33%;
   margin-bottom:12px;
}
.capture-rate{
   margin-left:30px;
}
.rank-provider-container,.rate-container{
  width:100%;
  height:431px;
}

.rank-provider{
   width:670px;
   height:556px;
   float:left;
   background-image: linear-gradient(180deg, rgba(0,228,255,0.03) 0%, rgba(0,228,255,0.00) 100%);
}
.capture-rate{
   width:600px;
   height:581px;
   padding-bottom:25px;
   float:left;
}
.block-title{
   height:67px;
   line-height:67px;
   width:100%;
   padding-left:30px;
}
.block-sub-title{
  //  height:60px;
  line-height:60px;
  height: 60px;
  width:100%;
  font-size:20px;
  color:#0efcff;
}
.block-big-title{
   font-size:30px;
   color:#0dffff;
}
.block-big-sub-title{
   font-size:20px;
   color:#0dffff;
}

.left-top{
  width:100%;
  box-sizing:border-box;
  // height:559px;
  height:33%;
  margin-bottom:25px;
}
html,body{
  width:100%;
  height:100%
}
.container{
  width:4088px;
  height:1730px;
  background: url(https://img.yimutian.com/crm/5ff566622d211f71026c88930ff80620.png) left top no-repeat;

  // background: url(http://img.yimutian.com/crm/5d9171f22d211f714f038edf4f7a4e65.jpeg) left top no-repeat;
  background-size:cover;
  font-family: 'PingFang SC', Microsoft YaHei;
}
.top{
  position:relative;
  width:100%;
  height:28px;
  // background:url(http://img.yimutian.com/crm/5d91723db827736e3b039009cfde3ee6.png) center center no-repeat;
  // background-size:contain;
  // text-align:center;
}

.bottom{
  width:100%;
  height:1703px;
}
.bottom>div{
  height:100%;
  float:left;
  // height:1703px;
  margin-left:28px;
  over-flow:hidden;
}
.left-section{
  width:1300px;
}
.middle-section{
  width:1376px;
}
.right-section{
  width:1300px;
  height:100%;
}
.tab_cantainer {
  margin-top: 21px;
}

.pull-right {
  float: right;
}
.clearfix {
  &:after {
    content: "";
    display: table;
    clear: both;
  }
}
.mark_tab {
  margin-top: 10px;
}
.title_bottom{
  // margin-bottom:16px;
  width:100%;
}
.hz-bg{
background-image: linear-gradient(180deg, rgba(0,228,255,0.03) 0%, rgba(0,228,255,0.00) 100%);
}
.right-tab-pos{
  position:absolute;
  right:40px;
  z-index:999;
}
.right-relative{
  position:relative;
}
.chart-size{
  height:80%;
}
.title-text{
  font-family: PingFang-SC-Medium;
  font-size: 36px;
  color: #60E0FF;
  position: absolute;
  margin:0;
}
.hz-title{
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  top:-4px;
  margin-bottom:16px;
}
</style>
